"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobxReactLite = require("mobx-react-lite");
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _api = require("../../services/api");
var _theme = require("../../theme");
var _reactNativeUiLib = require("react-native-ui-lib");
var _DynamicForm = _interopRequireWildcard(require("../DynamicForm"));
var _DynamicTable = _interopRequireDefault(require("../DynamicTable"));
var _native = require("@react-navigation/native");
var _reactNativeSvg = _interopRequireWildcard(require("react-native-svg"));
var _expoLinearGradient = require("expo-linear-gradient");
var _reactNativeShadow = require("react-native-shadow");
var _state = require("../state");
var _FormScreen = _interopRequireDefault(require("./FormScreen"));
var _reactRouterDom = require("react-router-dom");
var _antd = require("antd");
var _reactNativeEvaIcons = require("react-native-eva-icons");
var _LayoutScreen = _interopRequireDefault(require("./LayoutScreen"));
var _FABComponent = require("../../components/FABComponent");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, "return": function _return(r) { var n = this.s["return"]; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, "throw": function _throw(r) { var n = this.s["return"]; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); } // 
var ReportScreen = (0, _mobxReactLite.observer)(function ReportScreen(props) {
  var _window3;
  var navigation = (0, _native.useNavigation)();
  var navigate = null;
  var route = props === null || props === void 0 ? void 0 : props.route;
  if (_reactNative.Platform.OS === 'web') {
    var _window;
    navigate = (0, _reactRouterDom.useNavigate)();
    var path = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname;
    route = {
      name: path.split("/")[1] || 'Items'
    };
  }
  var navigationFn = function navigationFn(path, params) {
    if (_reactNative.Platform.OS === 'web') {
      var paramsString = "";
      if (params) {
        paramsString = "?" + Object.keys(params).map(function (key) {
          return key + '=' + params[key];
        }).join('&');
      }
      navigate("/" + path + paramsString);
    } else {
      if (path.includes("report/")) {
        navigation.navigate("report", _objectSpread(_objectSpread({}, params), {}, {
          name: path.replace("report/", "")
        }));
      } else {
        navigation.navigate(path, params);
      }
    }
  };
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    rows = _useState2[0],
    setRows = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    total = _useState4[0],
    setTotal = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    allColumns = _useState6[0],
    setAllColumns = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedColumns = _useState8[0],
    setSelectedColumns = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState9, 2),
    filters = _useState10[0],
    setFilters = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showFilter = _useState12[0],
    setShowFilter = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showExport = _useState14[0],
    setShowExport = _useState14[1];
  var _useState15 = (0, _react.useState)(1),
    _useState16 = _slicedToArray(_useState15, 2),
    pageIndex = _useState16[0],
    setPageIndex = _useState16[1];
  var _useState17 = (0, _react.useState)(20),
    _useState18 = _slicedToArray(_useState17, 2),
    pageSize = _useState18[0],
    setPageSize = _useState18[1];
  var _useState19 = (0, _react.useState)(''),
    _useState20 = _slicedToArray(_useState19, 2),
    sortColumn = _useState20[0],
    setSortColumn = _useState20[1];
  var _useState21 = (0, _react.useState)(''),
    _useState22 = _slicedToArray(_useState21, 2),
    sortDirection = _useState22[0],
    setSortDirection = _useState22[1];
  var _useState23 = (0, _react.useState)([]),
    _useState24 = _slicedToArray(_useState23, 2),
    selectedFilters = _useState24[0],
    setSelectedFilters = _useState24[1];
  var _useState25 = (0, _react.useState)(false),
    _useState26 = _slicedToArray(_useState25, 2),
    loading = _useState26[0],
    setLoading = _useState26[1];
  var _useState27 = (0, _react.useState)([]),
    _useState28 = _slicedToArray(_useState27, 2),
    ids = _useState28[0],
    setIds = _useState28[1];
  var _useState29 = (0, _react.useState)(null),
    _useState30 = _slicedToArray(_useState29, 2),
    groupBy = _useState30[0],
    setGroupBy = _useState30[1];
  var _useState31 = (0, _react.useState)(false),
    _useState32 = _slicedToArray(_useState31, 2),
    groupByModal = _useState32[0],
    setGroupByModal = _useState32[1];
  var _useState33 = (0, _react.useState)(''),
    _useState34 = _slicedToArray(_useState33, 2),
    search = _useState34[0],
    setSearch = _useState34[1];
  var _useState35 = (0, _react.useState)({
      field: null,
      label: null,
      operator: null,
      operator_label: null,
      operators: [],
      type: "text",
      value: null
    }),
    _useState36 = _slicedToArray(_useState35, 2),
    filter = _useState36[0],
    setFilter = _useState36[1];
  var getModuleData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _yield$api$get, data, _yield$api$get$all_co, all_columns, _yield$api$get$select, selected_columns, filters, allColumns;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.next = 3;
            return _api.api.get(route.name, {
              page: pageIndex,
              limit: pageSize,
              sortColumn: sortColumn,
              sortDirection: sortDirection,
              filters: selectedFilters,
              tabFilter: tabFilter,
              search: search,
              groupBy: groupBy
            });
          case 3:
            _yield$api$get = _context.sent;
            data = _yield$api$get.data;
            _yield$api$get$all_co = _yield$api$get.all_columns;
            all_columns = _yield$api$get$all_co === void 0 ? [] : _yield$api$get$all_co;
            _yield$api$get$select = _yield$api$get.selected_columns;
            selected_columns = _yield$api$get$select === void 0 ? [] : _yield$api$get$select;
            filters = _yield$api$get.filters;
            setRows((data === null || data === void 0 ? void 0 : data.data) || []);
            setTotal((data === null || data === void 0 ? void 0 : data.total) || 0);
            selected_columns = selected_columns.filter(function (column) {
              if (!column.field) {
                return false;
              }
              if (column.accessor == "actions") {
                return false;
              }
              column.Header = column.label;
              column.accessor = column.field;
              if (column.width) {
                var width = "" + column.width;
                column.width = width.replace('px', '');
              }
              return true;
            });
            if (selected_columns.length === all_columns.length) {
              selected_columns = selected_columns.filter(function (col) {
                return col.visible;
              });
            }
            selected_columns.push({
              Header: function Header(props) {
                return null;
              },
              accessor: 'actions',
              width: 75,
              minWidth: 75
            });
            allColumns = all_columns.map(function (col, index) {
              return _objectSpread(_objectSpread({}, col), {}, {
                id: index,
                visible: selected_columns.find(function (c) {
                  return c.field === col.field;
                }) ? true : false,
                width: selected_columns.find(function (c) {
                  return c.field === col.field;
                }) ? selected_columns.find(function (c) {
                  return c.field === col.field;
                }).width : 150
              });
            });
            setAllColumns(allColumns || []);
            setSelectedColumns(selected_columns || []);
            setFilters(filters || []);
            setLoading(false);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getModuleData() {
      return _ref.apply(this, arguments);
    };
  }();
  var _useStores = (0, _state.useStores)(),
    _useStores$modalStore = _useStores.modalStore,
    getOpenModals = _useStores$modalStore.getOpenModals,
    setOpenModal = _useStores$modalStore.setOpenModal,
    _useStores$layoutStor = _useStores.layoutStore,
    isSideBarCollapsed = _useStores$layoutStor.isSideBarCollapsed,
    toggleSideBarCollapsed = _useStores$layoutStor.toggleSideBarCollapsed,
    getSideBarPosition = _useStores$layoutStor.getSideBarPosition,
    setSideBarPosition = _useStores$layoutStor.setSideBarPosition;
  var actionFunctions = [{
    label: 'Edit',
    key: 'edit',
    fn: function fn(_ref2) {
      var data = _ref2.data,
        updateData = _ref2.updateData,
        row = _ref2.row,
        row_index = _ref2.row_index;
      if (_reactNative.Platform.OS === 'web') {
        navigationFn('Edit/' + route.name, {
          moduleName: route.name,
          id: row._id,
          goBackAfterSave: true,
          isEdit: true
        });
      } else {
        navigationFn('Edit', {
          moduleName: route.name,
          isEdit: true,
          id: row._id,
          viewOnly: true,
          goBackAfterSave: true
        });
      }
    }
  }, {
    label: 'Delete',
    key: 'delete',
    fn: function fn(_ref3) {
      var data = _ref3.data,
        updateData = _ref3.updateData,
        row = _ref3.row,
        row_index = _ref3.row_index;
      _api.api["delete"](route.name, row._id).then(function () {
        getModuleData();
      });
    }
  }, {
    label: 'Clone',
    key: 'clone',
    fn: function fn(_ref4) {
      var data = _ref4.data,
        updateData = _ref4.updateData,
        row = _ref4.row,
        row_index = _ref4.row_index;
      if (_reactNative.Platform.OS === 'web') {
        navigationFn('New/' + route.name, {
          moduleName: route.name,
          id: row._id,
          goBackAfterSave: true,
          isEdit: false
        });
      } else {
        navigationFn('New', {
          moduleName: route.name,
          isEdit: false,
          id: row._id,
          viewOnly: true,
          goBackAfterSave: true
        });
      }
    }
  }];
  var onCheckboxChange = function onCheckboxChange(newSet) {
    setIds(_toConsumableArray(newSet));
  };
  var saveColumns = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(columns) {
      var reload,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            reload = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;
            _context2.next = 3;
            return _api.api.saveColumns(route.name, {
              columns: columns
            });
          case 3:
            if (reload) {
              setTimeout(function () {
                getModuleData();
              }, 0);
            }
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function saveColumns(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    if (_reactNative.Platform.OS === 'web') {
      var _window2;
      var _path = (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.pathname;
      route = {
        name: _path.split("/")[1] || 'Items'
      };
      getModuleData();
      var results = _api.api.getForm(route.name);
      mobileCard = results.mobileCard;
      tabs = results.tabs;
    } else {
      var _results = _api.api.getForm(route.name);
      mobileCard = _results.mobileCard;
      tabs = _results.tabs;
      getModuleData();
    }
  }, [(_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.location) === null || _window3 === void 0 ? void 0 : _window3.pathname, search, groupBy, selectedFilters, sortColumn, sortDirection, pageIndex, pageSize]);
  var deleteModules = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, id;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context3.prev = 2;
            _iterator = _asyncIterator(ids);
          case 4:
            _context3.next = 6;
            return _iterator.next();
          case 6:
            if (!(_iteratorAbruptCompletion = !(_step = _context3.sent).done)) {
              _context3.next = 13;
              break;
            }
            id = _step.value;
            _context3.next = 10;
            return _api.api["delete"](route.name, id);
          case 10:
            _iteratorAbruptCompletion = false;
            _context3.next = 4;
            break;
          case 13:
            _context3.next = 19;
            break;
          case 15:
            _context3.prev = 15;
            _context3.t0 = _context3["catch"](2);
            _didIteratorError = true;
            _iteratorError = _context3.t0;
          case 19:
            _context3.prev = 19;
            _context3.prev = 20;
            if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) {
              _context3.next = 24;
              break;
            }
            _context3.next = 24;
            return _iterator["return"]();
          case 24:
            _context3.prev = 24;
            if (!_didIteratorError) {
              _context3.next = 27;
              break;
            }
            throw _iteratorError;
          case 27:
            return _context3.finish(24);
          case 28:
            return _context3.finish(19);
          case 29:
            getModuleData();
          case 30:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 15, 19, 29], [20,, 24, 28]]);
    }));
    return function deleteModules() {
      return _ref6.apply(this, arguments);
    };
  }();
  var Table = /*#__PURE__*/_react["default"].createElement(_DynamicTable["default"], {
    data: rows,
    updateData: function updateData(newData) {
      setRows(newData);
    },
    columns: selectedColumns,
    allColumns: allColumns,
    hideLabelOnMobile: true,
    CustomMobileCard: mobileCard,
    actions: true,
    actionFunctions: actionFunctions,
    cfAdd: true,
    saveColumns: saveColumns,
    isGrouped: groupBy ? true : false
    // total={total}
    // pageSize={pageSize}
    // pageIndex={pageIndex}
    // onQueryParams={onQueryParams}
    ,
    showCheckbox: true,
    onCheckboxChange: onCheckboxChange,
    onRowClick: function onRowClick(row) {
      setOpenModal(_defineProperty({}, route.name, {
        isVisible: true,
        moduleName: route.name,
        id: row._id,
        viewOnly: true
      }));
    },
    resizable: true
  });
  var newModule = function newModule() {
    if (_reactNative.Platform.OS === 'web') {
      var query = {};
      var params = window.location.search.substring(1).split('&');
      params.map(function (param) {
        var _param$split = param.split('='),
          _param$split2 = _slicedToArray(_param$split, 2),
          key = _param$split2[0],
          value = _param$split2[1];
        if (key) {
          query[key] = value;
        }
      });
      navigationFn('New/' + route.name, _objectSpread(_objectSpread({
        moduleName: route.name
      }, query), {}, {
        goBackAfterSave: true
      }));
    } else {
      navigationFn('New', {
        moduleName: route.name,
        goBackAfterSave: true
      });
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_LayoutScreen["default"], null, /*#__PURE__*/_react["default"].createElement(_reactNative.ScrollView, null, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    "marginT-2": true,
    "padding-16": true,
    style: _objectSpread(_objectSpread({}, $container), {}, {
      height: _reactNative.Dimensions.get('window').height - 80
    })
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    row: true,
    centerH: true,
    spread: true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    row: true,
    centerH: true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, {
    h1: true
  }, route.name), tabs && tabs.length > 0 && /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    flex: true,
    left: true,
    "marginL-10": true,
    style: {
      zIndex: 2
    },
    "w-100": true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    flex: true,
    "w-100": true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.SegmentedControl, {
    containerStyle: {
      justifyContent: 'center'
    },
    "padding-20": true,
    initialIndex: 0,
    borderRadius: 8,
    segments: tabs,
    outlineColor: "#E0E0E0",
    activeColor: "rgb(45, 45, 45)",
    inactiveColor: "rgb(45, 45, 45)",
    onChangeIndex: function onChangeIndex(index) {
      setTabFilter(tabs[index].value);
    }
  })))), _reactNative.Platform.OS == 'web' && !hideNewButton && /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Button, {
    label: "New",
    onPress: newModule,
    style: {
      marginLeft: 10
    }
  })), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    spread: true,
    centerV: true,
    row: true,
    "marginB-15": true,
    "marginT-10": true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    left: true,
    row: true,
    centerV: true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    "marginR-10": true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeEvaIcons.Icon, {
    name: "search-outline",
    width: 16,
    height: 16,
    fill: "#53535f"
  })), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.TextField, {
    placeholder: "Search",
    value: search,
    onChange: function onChange(e) {
      setSearch(e.nativeEvent.text);
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    "marginR-10": true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    style: {
      width: 1,
      height: 16,
      backgroundColor: '#e0e0e0',
      marginHorizontal: 10
    }
  }))), ids.length == 0 ? /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    row: true,
    centerV: true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Button, {
    avoidMinWidth: true,
    borderRadius: 4,
    backgroundColor: "#fff",
    style: [{
      boxShadow: '0 2px 0 rgba(0,0,0, 0.015)'
    }, {
      marginLeft: 10
    }],
    onPress: function onPress() {
      setShowFilter(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeEvaIcons.Icon, {
    name: "options-2-outline",
    width: 16,
    height: 16,
    fill: "#53535f"
  }), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    "marginL-5": true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, null, "Filter"))), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Button, {
    avoidMinWidth: true,
    borderRadius: 4,
    backgroundColor: "#fff",
    style: [{
      boxShadow: '0 2px 0 rgba(0,0,0, 0.015)'
    }, {
      marginLeft: 10
    }],
    onPress: function onPress() {
      setGroupByModal(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeEvaIcons.Icon, {
    name: "options-2-outline",
    width: 16,
    height: 16,
    fill: "#53535f"
  }), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    "marginL-5": true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, null, "Group By"))), _reactNative.Platform.OS == 'web' ? /*#__PURE__*/_react["default"].createElement(_antd.Dropdown, {
    menu: {
      items: [{
        label: 'Excel',
        onClick: function onClick() {
          download('excel');
        }
      }, {
        label: 'PDF',
        onClick: function onClick() {
          download('pdf');
        }
      }]
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Button, {
    borderRadius: 4,
    outline: true,
    outlineColor: "#edf2f9",
    style: [{
      boxShadow: '0 2px 0 rgba(0,0,0, 0.015)'
    }, {
      marginLeft: 6
    }],
    avoidMinWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeEvaIcons.Icon, {
    name: "cloud-download-outline",
    width: 16,
    height: 16,
    fill: "#53535f"
  }), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    "marginL-5": true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, null, "Export")))) : /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Button, {
    label: "Export",
    onPress: function onPress() {
      return setShowExport(true);
    },
    style: {
      marginLeft: 10
    }
  })) : /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    row: true,
    centerV: true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Button, {
    label: "Delete",
    onPress: function onPress() {
      deleteModules();
    },
    style: {
      marginLeft: 10
    }
  }))), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    left: true,
    "flex-5": true,
    flexG: true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    flex: true,
    style: {
      width: '100%'
    }
  }, !loading ? Table : /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, null, "Loading..."))), !hideNewButton && /*#__PURE__*/_react["default"].createElement(_FABComponent.FABComponent, {
    onPress: newModule
  }), /*#__PURE__*/_react["default"].createElement(_DynamicForm.CustomModal, {
    title: "Apply FIlters",
    visible: showFilter,
    onClose: function onClose() {
      return setShowFilter(false);
    }
  }, selectedFilters.length > 0 && /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    left: true,
    "marginT-20": true
  }, selectedFilters.map(function (filter, index) {
    return /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Chip, {
      key: index,
      label: "".concat(filter.label, " ").concat(filter.operator_label, " ").concat(filter.value),
      onPress: function onPress() {
        var selectedFiltersNew = _toConsumableArray(selectedFilters);
        selectedFiltersNew.splice(index, 1);
        setSelectedFilters(selectedFiltersNew);
      }
    });
  })), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    row: true,
    "marginT-20": true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    "marginR-10": true,
    flex: true
  }, /*#__PURE__*/_react["default"].createElement(_DynamicForm.CustomSelect, {
    label: "Field",
    options: filters.map(function (filter) {
      return {
        label: filter.label,
        value: filter.field
      };
    }),
    value: filter.field,
    onChange: function onChange(value) {
      var selectedFilter = filters.find(function (filter) {
        return filter.field === value;
      });
      var filterNew = _objectSpread({}, filter);
      filterNew.field = selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.field;
      filterNew.operators = selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.operators;
      filterNew.type = selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.type;
      filterNew.operator = selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.operators[0].value;
      filterNew.route = selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.route;
      filterNew.routeParams = selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.routeParams;
      setFilter(filterNew);
    }
  })), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    "marginR-10": true,
    flex: true
  }, /*#__PURE__*/_react["default"].createElement(_DynamicForm.CustomSelect, {
    label: "Operator",
    options: filter.operators || [],
    value: filter.operator,
    onChange: function onChange(value) {
      var filterNew = _objectSpread({}, filter);
      filterNew.operator = value;
      setFilter(filterNew);
    }
  })), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    flex: true
  }, filter.type == 'select' && /*#__PURE__*/_react["default"].createElement(_DynamicForm.CustomSelect, {
    label: "Value",
    options: filter.options || [],
    value: filter.value,
    onChange: function onChange(value) {
      var filterNew = _objectSpread({}, filter);
      filterNew.value = value;
      setFilter(filterNew);
    },
    searchRoute: filter.route,
    searchRouteParams: filter.routeParams
  }), filter.type == 'text' && /*#__PURE__*/_react["default"].createElement(_DynamicForm.CustomTextField, {
    label: "Value",
    value: filter.value,
    onChange: function onChange(value) {
      var filterNew = _objectSpread({}, filter);
      filterNew.value = value;
      setFilter(filterNew);
    }
  }), filter.type == 'number' && /*#__PURE__*/_react["default"].createElement(_DynamicForm.CustomNumberInput, {
    label: "Value",
    value: filter.value,
    onChange: function onChange(value) {
      var filterNew = _objectSpread({}, filter);
      filterNew.value = value;
      setFilter(filterNew);
    }
  }), filter.type == 'date' && /*#__PURE__*/_react["default"].createElement(CustomDatePicker, {
    label: "Value",
    value: filter.value,
    onChange: function onChange(value) {
      var filterNew = _objectSpread({}, filter);
      filterNew.value = value;
      setFilter(filterNew);
    }
  }), filter.type == 'datetime' && /*#__PURE__*/_react["default"].createElement(CustomDateTimePicker, {
    label: "Value",
    value: filter.value,
    onChange: function onChange(value) {
      var filterNew = _objectSpread({}, filter);
      filterNew.value = value;
      setFilter(filterNew);
    }
  }), filter.type == 'time' && /*#__PURE__*/_react["default"].createElement(CustomTimePicker, {
    label: "Value",
    value: filter.value,
    onChange: function onChange(value) {
      var filterNew = _objectSpread({}, filter);
      filterNew.value = value;
      setFilter(filterNew);
    }
  }), filter.type == 'boolean' && /*#__PURE__*/_react["default"].createElement(_DynamicForm.CustomSelect, {
    label: "Value",
    options: [{
      label: 'Yes',
      value: 'true'
    }, {
      label: 'No',
      value: 'false'
    }],
    value: filter.value,
    onChange: function onChange(value) {
      var filterNew = _objectSpread({}, filter);
      filterNew.value = value;
      setFilter(filterNew);
    }
  }))), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    "marginT-15": true,
    row: true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Button, {
    "marginR-10": true,
    label: "Add",
    onPress: function onPress() {
      var _filters$find, _filter$operators$fin;
      var selectedFiltersNew = _toConsumableArray(selectedFilters);
      var label = (_filters$find = filters.find(function (fil) {
        return fil.field === filter.field;
      })) === null || _filters$find === void 0 ? void 0 : _filters$find.label;
      var operator_label = (_filter$operators$fin = filter.operators.find(function (operator) {
        return operator.value === filter.operator;
      })) === null || _filter$operators$fin === void 0 ? void 0 : _filter$operators$fin.label;
      selectedFiltersNew.push({
        field: filter.field,
        label: label,
        operator: filter.operator,
        operator_label: operator_label,
        value: filter.value
      });
      setSelectedFilters(selectedFiltersNew);
      setFilter({
        field: null,
        label: null,
        operator: null,
        operator_label: null,
        operators: [],
        type: "text",
        value: null
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Button, {
    outline: true,
    label: "Clear All",
    onPress: function onPress() {
      setSelectedFilters([]);
    }
  }))), /*#__PURE__*/_react["default"].createElement(_DynamicForm.CustomModal, {
    drawer: true,
    title: "Group By",
    visible: groupByModal,
    onClose: function onClose() {
      setGroupByModal(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    flex: true,
    useSafeArea: true
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.TouchableOpacity, {
    onPress: function onPress() {
      setGroupByModal(false);
      setGroupBy(null);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    row: true,
    style: {
      cursor: 'grab'
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Image, {
    assetName: "drag",
    style: {
      width: 20,
      height: 20,
      opacity: 0.2
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, {
    "text-90N": true,
    grey10: true
  }, "None"))), allColumns.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.TouchableOpacity, {
      key: index,
      onPress: function onPress() {
        setGroupByModal(false);
        setGroupBy(item.field);
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
      row: true,
      style: {
        cursor: 'grab'
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Image, {
      assetName: "drag",
      style: {
        width: 20,
        height: 20,
        opacity: 0.2
      }
    }), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.Text, {
      "text-90N": true,
      grey10: true,
      key: item.field
    }, item.label)));
  }))), /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.ActionSheet, {
    useNativeIOS: true,
    visible: showExport,
    title: 'Title',
    message: 'Message goes here',
    cancelButtonIndex: 2,
    onDismiss: function onDismiss() {
      return setShowExport(false);
    },
    options: [{
      label: 'Excel',
      onPress: function onPress() {
        return download('excel');
      }
    }, {
      label: 'PDF',
      onPress: function onPress() {
        return download('pdf');
      }
    }, {
      label: 'Cancel',
      onPress: function onPress() {
        return setShowExport(false);
      }
    }]
  }))));
});
var _default = exports["default"] = ReportScreen;
var $container = {
  flex: 1
};